import { createResource } from 'lib/domonda-resource';
import { getReleasableInvoiceContainers } from 'lib/api/invoiceContainers';

export const releasableOverviewResource = createResource(getReleasableInvoiceContainers, {
  documentState: 'validated',
});
